import React from 'react';
import PropTypes from 'prop-types';
import { ButtonLink, CarouselHeaderWrapper } from './styled';

const CarouselHeader = ({ current, showModal, showViewAll, totalNoOfSets }) => {
  return (
    <CarouselHeaderWrapper direction="horizontal">
      <p style={{ margin: 0, color: '#748AA1' }}>
        Currently showing set <b>{String(current).padStart(2, '0')}</b> out of{' '}
        <b>{String(totalNoOfSets).padStart(2, '0')}</b>
      </p>

      {showViewAll && (
        <ButtonLink type="link" onClick={showModal}>
          View all sets and typologies
        </ButtonLink>
      )}
    </CarouselHeaderWrapper>
  );
};

CarouselHeader.prototype = {
  typologySets: PropTypes.array
};

export default CarouselHeader;
